<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/membershipSessionProrate')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateRegister">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Membership</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="membership_id" v-validate="'required'" v-model="addData.membership_id">
                      <option :value="null">Please select</option>
                      <option v-for="item in itemMembership" :key="item.id" :value="item.id">{{item.name}}</option>
                    </b-form-select>
                  </div>
                  <span class="error">{{ errors.first('membership_id') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Start Date</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="addData.start_date" name="start_date" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('start_date') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>End Date</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="addData.end_date" name="end_date" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('end_date') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Session Amount</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="addData.session_amount" name="session_amount" type="text"></b-form-input>
                  <span class="error">{{ errors.first('session_amount') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Session Price</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="addData.session_price" name="session_price" type="text"></b-form-input>
                  <span class="error">{{ errors.first('session_price') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Days in Month</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="addData.days_in_month" name="days_in_month" type="text"></b-form-input>
                  <span class="error">{{ errors.first('days_in_month') }}</span>
                </b-col>
              </b-row>
              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'

export default {
  name: 'addbranch',
  data: function () {
    return {
      itemMembership: [],
      itemCS: [],
      addData: {
        membership_id: null,
        start_date: '',
        end_date: '',
        session_amount: null,
        session_price: null,
        days_in_month: ''
      },
      options: [
        { value: null, text: 'Please select' },
        { value: 'active', text: 'Active' },
        { value: 'inactive', text: 'Inactive' }
      ]
    }
  },
  methods: {
    validateRegister () {
      this.$validator.validateAll().then((result) => {
        if(result) {
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.post('fitness/v1/alpha_session_prorate/', this.addData).then(response => {
            this.$router.push('/membershipSessionProrate')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            // console.log('error log', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    fetchData() {
      axios.get('fitness/v1/membership?sorting=name&sorting_type=asc&status=active').then(response => {
        this.itemMembership = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
